import { AxiosResponse } from 'axios';
import BaseService from "@/services/BaseService";
import ServiceResponseEntities from './response-models/ServiceResponseEntities';
import { Requisito } from '@/models/RequisitoBeneficio';
import { TipoPension } from '@/models/TipoPension';
export default class VejezAnticipadaService extends BaseService<any> {
    public constructor() {
        super("VejezAnticipada");
    }

    public async documentosRequeridos(step: string): 
    Promise<AxiosResponse<ServiceResponseEntities<Requisito[]>>> {
        return this.get('DocumentosRequeridos/'+ step);
    }

    public async tipoPension(): 
    Promise<AxiosResponse<ServiceResponseEntities<TipoPension[]>>> {
        return this.get('TipoDePension');
    }
}